import type { AddNoteRequest } from '@contracts/note/AddNoteRequest';
import { OrdersClient } from '@src/orders/services/OrdersClient';
import { useMutation } from '@tanstack/react-query';

type Props = {
  orderId: string;
  onSuccess: () => void;
  onError: () => void;
};

export const useCancelPermit = ({ orderId, onSuccess, onError }: Props) => {
  const { mutate } = useMutation({
    mutationFn: (data: { permitApplicationId: string; note: AddNoteRequest }) =>
      OrdersClient.cancelPermit({
        orderId,
        permitApplicationId: data.permitApplicationId,
        note: data.note,
      }),
    onSuccess,
    onError,
  });

  return {
    cancelPermit: mutate,
  };
};
